export const deleteDocumentHard = (payload?: any) => ({
    type: "@saga/DELETE_DOCUMENT_HARD",
    payload
});

